import React from "react";
import Breadcrumbs from "../components/Breadcrums";
import CallIcon from "@mui/icons-material/Call";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageIcon from "@mui/icons-material/Language";
import { ReservationOptions } from "../configs";

const iconMap: Record<string, JSX.Element> = {
  CallIcon: <CallIcon />,
  LanguageIcon: <LanguageIcon />,
  InstagramIcon: <InstagramIcon />,
};

const breadcrumbItems = [
  { label: "Home", path: "/" },
  { label: "Reserve", path: "/reserve" },
];

function Reserve() {
  return (
    <div className="flex flex-col justify-start p-3 lg:p-3 ">
      <Breadcrumbs items={breadcrumbItems} />
      <h1 className="hidden lg:block text-2xl font-bold text-primary-main mt-5">
        Make Your Reservation
      </h1>
      <p className="text-sm text-primary-main text-opacity-90 mt-2">
        Choose the most convenient way to reserve your stay with us.
      </p>
      <div className="flex flex-col lg:flex-row gap-3 mt-5">
        {ReservationOptions.map((option, index) => {
          return (
            <div
              key={index}
              className="flex flex-auto min-w-100 flex-col p-5 bg-primary-main rounded-lg 
              border-primary-main hover:shadow-xl hover:bg-opacity-70"
              onClick={() => window.open(option.link, "_blank")}
            >
              <div className="flex items-center gap-3">
                {iconMap[option.icon]}
                <h2 className="text-lg font-bold text-secondary-main">
                  {option.title}
                </h2>
              </div>
              <p className="flex flex-col text-sm text-secondary-medium mt-2 gap-3">
                {option.description.map((desc, idx) => (
                  <span key={idx}>{desc}</span>
                ))}
                {option.link && (
                  <a
                    href={option.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary-main underline mt-2"
                  >
                    {option.linkLabel}
                  </a>
                )}
              </p>
            </div>
          );
        })}
      </div>
      <p className="text-sm text-primary-main text-opacity-90 mt-5 mb-3">
        For any special requests or inquiries, feel free to reach out to us.
        We’re here to assist you!
      </p>
    </div>
  );
}

export default Reserve;
